import { useNavigate } from 'react-router-dom';
import Button from '@/components/form/Button';

interface SnapFeedEmptyProps {
  showVoted: boolean;
  hasVotedSnaps: boolean;
  onToggleMode: () => void;
  onClose: () => void;
  error?: string | null;
  onRetry?: () => void;
}

export default function SnapFeedEmpty({ 
  showVoted, 
  hasVotedSnaps, 
  onToggleMode, 
  onClose,
  error,
  onRetry
}: SnapFeedEmptyProps) {
  const navigate = useNavigate();

  if (error) {
    return (
      <div className="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center p-4 text-white">
        <h2 className="text-2xl font-bold mb-4">Something went wrong</h2>
        <p className="mb-6">{error}</p>
        {onRetry && <Button onClick={onRetry}>Try Again</Button>}
        <Button variant="ghost" onClick={onClose} className="mt-4 text-white">
          Back to Dashboard
        </Button>
      </div>
    );
  }

  if (!showVoted) {
    return (
      <div className="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center p-4 text-white">
        <h2 className="text-2xl font-bold mb-4">No New SNAPs Found</h2>
        <p className="mb-6">You've voted on all available SNAPs!</p>
        <div className="flex space-x-4">
          <Button onClick={() => navigate('/create')}>Create a SNAP</Button>
          {hasVotedSnaps && (
            <Button variant="secondary" onClick={onToggleMode}>
              View Voted SNAPs
            </Button>
          )}
        </div>
        <Button variant="ghost" onClick={onClose} className="mt-4 text-white">
          Back to Dashboard
        </Button>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center p-4 text-white">
      <h2 className="text-2xl font-bold mb-4">No Voted SNAPs</h2>
      <p className="mb-6">You haven't voted on any SNAPs yet.</p>
      <div className="flex space-x-4">
        <Button onClick={onToggleMode}>Discover SNAPs</Button>
        <Button variant="secondary" onClick={() => navigate('/create')}>
          Create a SNAP
        </Button>
      </div>
      <Button variant="ghost" onClick={onClose} className="mt-4 text-white">
        Back to Dashboard
      </Button>
    </div>
  );
}